import React from 'react';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'updated_at', label: 'updated_at' },
  { id: 'pnl', label: 'pnl' },
  { id: 'volume', label: 'volume' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'user_ids', label: 'User IDs' },
  { id: 'ai_labels2', label: 'AI Labels' },
  { id: 'tags2', label: 'Tags' },
  { id: 'is_null', label: 'Is Null' },
  { id: 'date', label: 'Date Range' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
  { id: 'author_in_app_users', label: 'In-App Users (your pushed wallets)' },
];

const PolymarketWalletsQuery = () => {
  return <QueryModes source="polymarket-wallets"
            sortOptions={SORT_OPTIONS}
            strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
            boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
  />;

};

export default PolymarketWalletsQuery;

